var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "summary__address w-100 w-third-ns" }, [
    _c("div", { class: { deactive: _vm.selected != _vm.address.id } }, [
      _c("b", [
        _vm._v(_vm._s(_vm.address.name) + " " + _vm._s(_vm.address.surname))
      ]),
      _c("br"),
      _vm._v(" "),
      _vm.address.company_name || _vm.address.companyName
        ? _c("span", [
            _vm._v(
              "\n            " +
                _vm._s(_vm.address.company_name || _vm.address.companyName)
            ),
            _c("br")
          ])
        : _vm._e(),
      _vm._v("\n        " + _vm._s(_vm.address.address)),
      _c("br"),
      _vm._v(
        "\n        " +
          _vm._s(_vm.address.city) +
          ", " +
          _vm._s(_vm.address.zip_code) +
          " " +
          _vm._s(_vm.address.district)
      ),
      _c("br"),
      _vm._v(
        "\n        " +
          _vm._s(_vm.address.country.iso_code || _vm.address.country)
      ),
      _c("br"),
      _vm._v("\n        " + _vm._s(_vm.address.telephone) + "\n    ")
    ]),
    _vm._v(" "),
    _vm.selected != _vm.address.id
      ? _c(
          "button",
          {
            on: {
              click: function($event) {
                return _vm.$emit("set-address-on", _vm.address.id)
              }
            }
          },
          [_vm._v("\n        " + _vm._s(_vm.strings["select"]) + "\n    ")]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }